var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"sidebar-link"},[(!_vm.external)?_c('router-link',{staticClass:"sidebar-link__router-link",attrs:{"to":_vm.to,"target":_vm.target}},[_vm._t("title")],2):_c('a',{staticClass:"sidebar-link__router-link",attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("title")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }